import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import Vant from "vant";
import "vant/lib/index.css";
import { Toast, Notify } from "vant";
import ElementUI from "element-ui";
import Mui from "vue-awesome-mui";
import Vuex from "vuex";
import Vconsole from "vconsole";
import CallApp from 'callapp-lib';
// new Vconsole();

Vue.use(Vuex);
Vue.use(Mui);
Vue.use(ElementUI);
// mui.init({
      //   keyEventBind: {
      //     backbutton: true, //关闭back按键监听
      //   }
      // })
      //首页返回键处理
      // 处理逻辑： 1s内，连续两次按返回键，则退出应用；
      var first = null;
      mui.back = function(){
        // 首次按键， 提示 再按一次退出应用
        if(!first){
          first = new Date().getTime();//记录第一次按下回退键的时间
          mui.toast("再按一次退出应用");z
          history.go(-1); // 回退到上一页
          setTimeout(function(){
            //1s 后清除
            first = null;
          }, 1000);

        }else{
          if(new Date().getTime() - first < 1000){
            //如果两次按下的时间小于1s
            plus.runtime.quit(); //那么就退出app
          }
        }
      }
//Vue.use(CallApp);
import "element-ui/lib/theme-chalk/index.css";
import "lib-flexible/flexible.js";

Vue.config.productionTip = false;
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  timeout: 5000 // request timeout
});
// 提交表单的
// token加入header
let toast = null;
service.interceptors.request.use(
  config => {
    // console.log(store.state)
    toast = Toast.loading({
      mask: true,
      message: "加载中..."
    });
    // if (store.state.userInfo.token) {
    //   config.headers['token'] = store.state.userInfo.token // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    // }
    // if (config.formState) {
    //   config.data = qs.stringify(config.data)
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    // }
    // if (/\/file\//.test(config.url)) {
    //   //config.url = 'http://39.98.207.235:8090' + config.url.substring(5);
    // } else {
    //   config.url = 'http://39.98.207.235:8080' + config.url
    // }
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);
// axios全局拦截配置
service.interceptors.response.use(
  response => {
    if (toast) {
      toast.clear();
    }
    toast = null;
    if (response.data.code === 600) {
      return {
        success: true,
        data: response.data.data
      };
    } else {
      // Notify(response.data.msg)
      return {
        success: false,
        msg: response.data.msg
      };
    }
  },
  error => {
    if (error.response) {
      console.log("error message");
    }
    return Promise.reject(error); // 返回接口返回的错误信息
    // return Promise.reject(error.response.data) // 返回接口返回的错误信息
  }
);


//新建axios拦截配置,
//思路---------
//前端在登录的时候拿到一个token，并且这个token是又时效限制的
//1.判断是否存在token
//2.判断token是否失效,失效返回登录页
//3.一定时间内需要刷新token
//接口返回的状态码:701代表过期
axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token');
    if (!config.headers.hasOwnProperty('token') && token) {
      config.headers.common['X-Access-Token'] = token
    }
    return config;
  },
  error => {

    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    //console.log(response)
    if (response.data.code == 701) {
      //701token失效 返回登陆页面并且删除token
      localStorage.clear()
      router.replace({
        path: "/login"
      })
    }
    return response;

  },
  error => {
    // if(error.response){
    //   switch(error.response.code){
    //     case 701:
    //       this.$store.commit('delToken');
    //       router.replace({
    //         path:"/login",
    //       })
    //   }
    // }
    if (error.response) {
      console.log("error message");
    }
    return Promise.reject(error); // 返回接口返回的错误信息
  }
)


Vue.prototype.$http = service;

Vue.use(Vant);
/* eslint-disable no-new */

const store = new Vuex.Store({
  state: {
    showflag: false,
    position: false,
    lastNode: {},
    markList: [],
    coord: []
  },
  mutations: {
    changeShow(state) {
      state.showflag = true;
    },
    tellMapFrom(state, status) {
      state.position = status;
    },
    updateList(state, res) {
      state.markList = res;
    },
    updateCO(state, res) {
      state.coord = res;
    },
    //自定义存储和删除token的方法,用来做登录验证
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token.token);   //存储token
    },
    delToken(state) {
      state.token = "";
      localStorage.removeItem("token");   //删除token
    }

  },
  getters: {
    getPosition(state) {
      return state.position;
    }
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js